import { render, staticRenderFns } from "./PublicPhotos.vue?vue&type=template&id=12741417&scoped=true&"
import script from "./PublicPhotos.vue?vue&type=script&lang=js&"
export * from "./PublicPhotos.vue?vue&type=script&lang=js&"
import style0 from "./PublicPhotos.vue?vue&type=style&index=0&id=12741417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12741417",
  null
  
)

export default component.exports